import type React from 'react';

import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import { withFlags } from '@confluence/flags/entry-points/withFlags';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

import { useLoomAiMeetingNotesPostProvisionFlag } from './hooks/useLoomAiMeetingNotesPostProvisionFlag';

interface LoomAiMeetingNotesPostProvisionFlagGlobalProps {
	flags: FlagsStateContainer;
}

/**
 * Global component that monitors Loom touchpoint variant changes and shows a flag
 * when the variant changes to CROSSJOIN. This should be rendered once globally
 * to ensure the flag appears on any page where the state change occurs.
 */
export const LoomAiMeetingNotesPostProvisionFlagGlobalBase: React.FC<
	LoomAiMeetingNotesPostProvisionFlagGlobalProps
> = ({ flags }) => {
	useLoomAiMeetingNotesPostProvisionFlag({
		flags,
		enabled: UNSAFE_expValEqualsNoExposure(
			'loom_ai_meeting_notes_in_confluence_experiment',
			'cohort',
			'variation',
		),
	});

	// This component doesn't render anything visible - it just monitors state changes
	return null;
};

/**
 * HOC-wrapped version with flags automatically injected.
 * Use this in GlobalComponents.tsx
 */
export const LoomAiMeetingNotesPostProvisionFlag = withFlags(
	LoomAiMeetingNotesPostProvisionFlagGlobalBase,
);
